import { render, staticRenderFns } from "./AddCommentsBulk.vue?vue&type=template&id=0b70c829"
import script from "./AddCommentsBulk.vue?vue&type=script&lang=js"
export * from "./AddCommentsBulk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports